<div class="autocomplete-search" fxLayout="row" fxLayoutAlign="space-between center">
  <label class="autocomplete-hint">{{ autocompleteHint }}:</label>

  <mat-form-field class="autocomplete-field">
    <input matInput [matAutocomplete]="autocomplete" [formControl]="input" autocomplete="off" />
  </mat-form-field>

  <mat-autocomplete #autocomplete="matAutocomplete" [displayWith]="displayWith" (optionSelected)="onOptionSelected($event.option.value)">
    @if (isAutocompleteLoading) {
    <mat-option>
      <mat-spinner strokeWidth="2" diameter="20" color="accent"></mat-spinner>
    </mat-option>
    } @if (!isAutocompleteLoading) { @for (option of autocompleteOptions; track $index) {
    <mat-option [value]="option">
      <span>{{ displayWith(option) }}</span>
    </mat-option>
    } }
  </mat-autocomplete>

  <button mat-icon-button type="button" class="add-button" [disabled]="!selectedOption" (click)="addSelectedOptionToList()">
    <mat-icon svgIcon="add_circle_outline"></mat-icon>
  </button>
</div>

<ul class="items-list" linPerfectScrollbar>
  @for (item of itemList; track $index) {
  <li class="item" fxLayout="row" fxLayoutAlign="space-between center">
    <span class="item-title">{{ displayWith(item) }}</span>
    <button mat-icon-button type="button" class="item-delete-button" (click)="deleteItem(item)">
      <mat-icon svgIcon="highlight_off"></mat-icon>
    </button>
  </li>
  }
</ul>
